<template>
  <div class="mainBox" :style="{ 'min-height': mainBoxHeight }">
    <el-alert type="warning">亲爱的 <font style="color:#ce6902;font-weight:bold;">{{username}}</font> 你好！欢迎使用数据填报助手。</el-alert>
    <el-form label-width="100px" style="display: block !important">
      <el-row :gutter="24">
        <el-col
          v-for="(item, index) in paperList"
          v-bind:key="index"
          :xs="24"
          :sm="12"
          :md="12"
          :lg="12"
          :xl="12"
        >
          <br />
          <router-link
            :to="'/pageOneList?id=' + (item.paperId == 'P202101005'?'':item.paperId)"
            style="text-decoration: none"
          >
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span style="font-weight: bold; color: rgb(96, 98, 102)">{{
                  ++index + "." + item.title + "  [" + item.createTime + "]"
                }}</span>
              </div>
              <div style="color: #9fca37; font-size: 14px">
                {{ item.note }}
              </div>
            </el-card>
          </router-link>
        </el-col>
      </el-row>
    </el-form>
    <br />
     <div style="text-align: center">
      <el-pagination
        background
        :hide-on-single-page="true"
        layout="prev, pager, next"
        :pager-count="5"
        :page-count="this.pageNum"
        :page-size="this.pageSize"
        :total="this.pageTotal"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
    
    <br />
    <br />
    <br />
  </div>
</template>

<script>
import { Get_Paper_List } from "@/api/pageOne/ApiIndex.js";
import {checkLoginAction} from '@/api/login.js'
import {createTable,from,Filter,dateChange} from '@/api/jsDb/dbms.js'
var jsdb ;

export default {
  data() {
    return {
      mainBoxHeight: "0px",
      activeNames: ["1"],
      dialogVisible: false,
      paperList: [],
      username:"",
      pageNum:1,
      pageSize:10,
      pageTotal:0
    };
  },
  mounted() {
    this.mainBoxHeight =
      (document.documentElement.clientHeight || document.body.clientHeight) +
      "px";
  },
  created() {
    Get_Paper_List().then((response) => {
      jsdb = from(response.data.data)
      let jsQuery = {
          pageNum:this.pageNum,
          pageSize:this.pageSize,
      }
      
      let rezlut = jsdb.page(jsQuery);
      this.pageTotal = rezlut.total;
      this.paperList = rezlut.rows;
    });
    checkLoginAction({token:sessionStorage.getItem("token")+Math.random()}).then(response => {
      this.username = response.data.realname;
    })
  },
  methods: {
    goBack() {
      // console.log("go back");
    },
    handleChange(val) {
      // console.log(val);
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    typeIn(itemId) {
      this.dialogVisible = true;
    },
    handleCurrentChange(index){
      this.pageNum = index
      let jsQuery = {
          pageNum:this.pageNum,
          pageSize:this.pageSize,
      }
      
      let rezlut = jsdb.page(jsQuery);
      this.pageTotal = rezlut.total;
      this.paperList = rezlut.rows;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
//<!--3.1、样式区-->
<style type="text/css" scoped>
.mainBox {
  max-width: 900px;
  margin: 0px auto 10px auto;
  background-color: #fffdf7;
  border-style: dotted;
  border-width: thin;
  padding: 10px 10px;
  border-color: gainsboro;
  border-radius: 10px;
}
/**控制本页边界 */
.el-form-item {
  margin-bottom: 10px !important;
}
.el-table .cell {
  line-height: 14px !important;
}
.el-divider--horizontal {
  margin: 10px 0 !important;
}
.el-dialog__body {
  padding: 0px 20px 20px 20px !important;
}
/**解决form无高度问题 */
.el-form {
  display: inline-block !important;
}
.el-table--mini th,
.el-table--mini td {
  padding: 0px !important;
}
.el-table--small th,
.el-table--small td {
  padding: 4px !important;
}
.el-table .cell {
  line-height: 16px !important;
}
.el-divider--horizontal {
  margin: 12px 0px !important;
}
.el-card {
  /* border-radius: 16px !important; */
  /* background-color: #fdfbf8 !important; */
  box-shadow: 1px 1px 3px #bebebe;
}
.el-dialog {
  border-radius: 16px !important;
}
.light:hover {
  color: red !important;
}
.el-badge__content.is-fixed {
  z-index: 20 !important;
}
</style>
<style type="text/css">
.el-dialog {
  border-radius: 12px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/index.vue